import { Avatar, Collapse, ListItem, ListItemAvatar, ListItemIcon, ListItemProps, ListItemText } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import React from 'react';

interface Props extends ListItemProps {
    icon?: React.ReactNode;
    avatar?: React.ReactElement;
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

function ListItemCollapse(props: Props) {

    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <React.Fragment>
            <ListItem button style={props.style} onClick={handleClick}>
                {props.icon &&
                    <ListItemIcon>
                        {props.icon}
                    </ListItemIcon>
                }
                {props.avatar &&
                    <ListItemAvatar>
                        <Avatar>
                            {props.avatar}
                        </Avatar>
                    </ListItemAvatar>
                }
                <ListItemText primary={props.title} secondary={props.subtitle} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                {props.children}
            </Collapse>
        </React.Fragment>
    );
}

export default ListItemCollapse;